module.exports = __webpack_public_path__ + "img/comiccon-africa.66c689e6.png";